import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=7245f762&scoped=true"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=7245f762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245f762",
  null
  
)

export default component.exports